// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__BMBhW"};